import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[unassistedInput]',
  standalone: true
})
export class UnassistedInputDirective implements OnInit {
  @Input() autocapitalize: 'on' | 'off' = 'off';
  @Input() autocorrect: 'on' | 'off' = 'off';
  @Input() autocomplete: 'on' | 'off' = 'off';
  @Input() spellcheck: boolean = false;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit() {
    this.renderer.setAttribute(this.el.nativeElement, 'autocapitalize', this.autocapitalize);
    this.renderer.setAttribute(this.el.nativeElement, 'autocorrect', this.autocorrect);
    this.renderer.setAttribute(this.el.nativeElement, 'autocomplete', this.autocomplete);
    this.renderer.setProperty(this.el.nativeElement, 'spellcheck', this.spellcheck);
  }
}